// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fq","advertDetailContacts__header":"c-n_fr"};